import React from 'react'
import {
  styled,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useDispatch } from 'react-redux'
import { CLOSE_DIALOG } from '../../../redux/dialogReducer.jsx'
import AssignACSUsersList from '../assignUserToAcsDffEntitlement/AssignACSUsersList.jsx'

const HintContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}))

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}))

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
}))
const StyledContent = styled(DialogContent)(({ theme }) => ({
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
}))

export default function AssignAdminToAcsDffEntitlementDialog({
  targetEntitlement,
  setNeedsFetchData,
}) {
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch({ type: CLOSE_DIALOG })
  }

  return (
    <>
      <StyledDialogTitle>
        <Typography variant="h6">
          Assign admin to entitlement: {targetEntitlement.entitlementId}
        </Typography>
        <CloseButton aria-label="close" onClick={handleClose} color="secondary">
          <CloseIcon color="secondary" />
        </CloseButton>
      </StyledDialogTitle>
      <StyledContent>
        <HintContainer>
          Find the user you would like to assign as admin to this entitlement.
        </HintContainer>
        <HintContainer>
          The user will have admin privileges on the entitlement.
        </HintContainer>
        <HintContainer>
          Unassignment is not possible for 10 days after being assigned.
        </HintContainer>

        <AssignACSUsersList
          assignAsAdmin={true}
          targetEntitlement={targetEntitlement}
          handleClose={handleClose}
          setNeedsFetchData={setNeedsFetchData}
        />
      </StyledContent>
    </>
  )
}
